import React from "react";
import gears_logo from "@assets/gears_logo.png";
import gears_logo_2x from "@assets/gears_logo@2x.png";
import { Link as RouterLink } from "react-router-dom";
import { Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  logo: {
    display: "block",
    width: "195px",
    height: "49px",
    margin: "6px 0",
  },
});

export const Logo: React.FC = () => {
  const classNames = useStyles();

  return (
    <Box flexGrow={1}>
      <RouterLink to="/">
        <img
          src={gears_logo}
          srcSet={`${gears_logo} 1x, ${gears_logo_2x} 2x`}
          alt="GEARS"
          className={classNames.logo}
        />
      </RouterLink>
    </Box>
  );
};
